import { DatasetUnit } from 'src/redux/helpers';

export enum PlatformVersionField {
  EdgeComponentName = 'edgeComponentName',
  DockerImage = 'dockerImage',
  Version = 'version',
  Action = 'action',
}

export type PlatformVersionItem = {
  id?: string;
  edgeComponentName: string;
  dockerImage: string;
  version: string;
};

export type PlatformVersionsList = {
  data?: PlatformVersionItem[];
};

export type PlatformVersionsStore = DatasetUnit<PlatformVersionsList>;
